import toml from "refractor/toml";
export default toml;